import store from '@/store/index'
import navguard from '../api/navguard.api'

const requireAdmin = (to, from, next) => {
  if (store.getters.currentUser === null || store.getters.currentUser.is_superuser) {
    next()
  } else {
    next('/home')
  }
}

const canSeeTeam = (to, from, next) => {
  navguard.api.teamNavGuard(to.params.id)
  .then(response => {
    next()
  },
  error => {
    next('/teams')
    console.log(error)
  })
}

export default {
  requireAdmin, canSeeTeam
}



// WEBPACK FOOTER //
// ./src/router/guards.js